import React, { useMemo } from 'react';
import { Flex } from '@chakra-ui/react';
import { ColumnDef } from '@tanstack/react-table';
import { CategoryQuantity, CategorySummary } from 'api/types';

import { TableType } from '../../../../../common/components/Table/model/enums/table-type.enum';
import { Table } from '../../../../../common/components/Table/Table';
import { TableItemWithImage } from '../../../../../common/components/TableItemWithImage';
import { useTranslations } from '../../../../../contexts/LocalizationContext';
import { useLocalizationContext } from '../../../../../contexts/LocalizationContext/useLocalizationContext.hook';
import CategoriesListItem from './CategoriesListItem';

type Props = {
  updateQuantityOfItemsInCategory: (categoryId: string, quantity: number) => void;
  categoriesToCreate: CategoryQuantity;
  categories: CategorySummary[];
  disabled: boolean;
};

const CategoriesList = ({ updateQuantityOfItemsInCategory, categoriesToCreate, categories, disabled }: Props) => {
  const translations = useTranslations();
  const { language } = useLocalizationContext();

  const columns = useMemo<ColumnDef<CategorySummary>[]>(
    () => [
      {
        id: 'category',
        header: translations('category_list_category'),
        cell: ({ row }) => (
          <TableItemWithImage
            text={row.original.translations ? row.original.translations[language] : ''}
            imageUrl={row.original.imageUrl}
          />
        ),
      },
      {
        id: 'quantity',
        header: translations('category_list_quantity'),
        cell: ({ row }) => (
          <Flex w={'100%'} justifyContent="flex-end">
            <CategoriesListItem
              key={row.original.id}
              category={row.original}
              updateQuantityOfItemsInCategory={updateQuantityOfItemsInCategory}
              categoryQuantity={categoriesToCreate[row.original.id] || 0}
              disabled={disabled}
            />
          </Flex>
        ),
      },
    ],
    [categoriesToCreate, language, translations, updateQuantityOfItemsInCategory, disabled],
  );

  return <Table type={TableType.SIMPLE} data={categories} columns={columns} showHeader={false} />;
};

export default CategoriesList;
